import { PlanAdditionalInfo } from './plan-additional-info'

export default PlanAdditionalInfo
